<template>
    <div class="no-access-text">
        <div v-if="!authState.loggedIn">
            <div>
                The full report is available to subscribers only.
                <font-awesome-icon :icon="['fas', 'lock-keyhole']" class="user-access" />
                <br><br>
            </div>
            Please log in to view if you have the required subscription
            <primevue-button @click="login()" class="plain-btn">
                Login
                <font-awesome-icon :icon="['fas', 'fa-right-to-bracket']" />
            </primevue-button>
            <br><br>
            If you'd like access to this report, please contact us to discuss the subscriptions available.
            <primevue-button @click="openContactForm" class="plain-btn">
                Contact Us
                <font-awesome-icon :icon="['fas', 'envelope']" />
            </primevue-button>
        </div>
        <div v-else>
            <p>
                You currently don't have access to this report.
                <font-awesome-icon :icon="['fas', 'lock-keyhole']" class="user-access" />
            </p>
            <p>
                Please contact
                <primevue-button class="contact-button" text @click="openContactForm">LCP Delta</primevue-button>
                if you require access.
            </p>
        </div>
    </div>
    <contact-form v-model:visible="showContactFormModal" prefill-text="I would like access to this report." />
</template>

<script lang="ts" setup>
import { authState, login } from '@lcp/http-auth';
import primevueButton from 'primevue/button';
import { ref } from 'vue';
import ContactForm from './ContactForm.vue';

const showContactFormModal = ref<boolean>(false);

function openContactForm (): void {
    showContactFormModal.value = true;
}

</script>

<style lang="scss" scoped>

.no-access-text {
    width: fit-content;
    font-size: var(--largeFontSize);
    text-align: center;
    background-color: var(--neutral200);
    padding: 2rem;
    border-radius: var(--borderRadiusOuter);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    .plain-btn {
        margin-left: var(--defaultSpacing);
    }
    .user-access {
        color: var(--lcpSunrise);
        opacity: 0.8;
        margin-left: var(--largeSpacing);
        font-size: 3rem;
    }
}

</style>
